export default (width=null) =>  ({
    control: (base) => ({
        ...base,
        minHeight: '2.6em',
        height: '32px',
        borderRadius: 0,
        borderColor: 'grey',
        width: width || '13.5em',
        overflow: 'none',
        fontSize: 11
    }),
        indicatorsContainer: (base) => ({
    ...base,
    height: '2.6em'
}),
    valueContainer: (provided, state) => {
    return ({
        ...provided,
        // height: '23px',
        // height: '32px',
        padding: '0 0 0 4px'
    })
},
    singleValue: (provided, state) => ({
    ...provided,
    // marginLeft: '1px',
    // marginRight: '1px'
}),
    menu: (provided, state) => ({
    ...provided,
    width: '20em',
    // zIndex: 10

}),
    input: (provided, state) => ({
    ...provided,
    // margin: '0px',
    // padding: 0
}),
    dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    width: '12px'
}),
    indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
}),
    clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
}),
    groupHeading: (base) => ({
    ...base,
    ':hover': {
        backgroundColor: 'yellow'
    }
}),
    multiValue: (base) => ({
    ...base,
    display: 'none'
}),
    placeholder: (base) => ({
    ...base,
    whiteSpace: 'nowrap'
}),
    option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#ecf' : base.backgroundColor,
    color: 'black'
}),
    menuList: (base) => ({
    ...base,
    height: 'auto',
    maxHeight: '450px'

})
})
